import {UserRole} from "@/shared/enums/UserRolesEnums";
import AssistedLivingCoachingList
    from "@/views/App/Analytics/Coach/AppointmentEvaluation/AssistedLivingCoaching/List.vue";
import CaseManagementCoachingList
    from "@/views/App/Analytics/Coach/AppointmentEvaluation/CaseManagementCoaching/List.vue";
import GroupCoachingList from "@/views/App/Analytics/Coach/AppointmentEvaluation/GroupCoaching/List.vue";
import JobCoachingList from "@/views/App/Analytics/Coach/AppointmentEvaluation/JobCoaching/List.vue";
import OccupationalTherapyCoachingList
    from "@/views/App/Analytics/Coach/AppointmentEvaluation/OccupationalTherapyCoaching/List.vue";
import PrivateLearningCoachingList
    from "@/views/App/Analytics/Coach/AppointmentEvaluation/PrivateLearningCoaching/List.vue";
import SocioTherapyCoachingList from "@/views/App/Analytics/Coach/AppointmentEvaluation/SocioTherapyCoaching/List.vue";
import PrivateCoachingList from "@/views/App/Analytics/Coach/AppointmentEvaluation/PrivateCoaching/List.vue";

import CoachOverviewList from "@/views/App/Analytics/Coach/Overview/List.vue";

const routesAnalyticsCoach = [
    {
        path: "coach/overview",
        name: "coachOverview",
        component: CoachOverviewList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_SUPPORT,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "coach/appointment-evaluation/private-coaching",
        name: "coachAppointmentEvaluationPrivateCoaching",
        component: PrivateCoachingList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_SUPPORT,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.PRACTICE_MANAGER,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "coach/appointment-evaluation/assisted-living-coaching",
        name: "coachAppointmentEvaluationAssistedLivingCoaching",
        component: AssistedLivingCoachingList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_SUPPORT,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "coach/appointment-evaluation/case-management-coaching",
        name: "coachAppointmentEvaluationCaseManagementCoaching",
        component: CaseManagementCoachingList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_SUPPORT,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.PRACTICE_MANAGER,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "coach/appointment-evaluation/group-coaching",
        name: "coachAppointmentEvaluationGroupCoaching",
        component: GroupCoachingList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_SUPPORT,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "coach/appointment-evaluation/job-coaching",
        name: "coachAppointmentEvaluationJobCoaching",
        component: JobCoachingList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_SUPPORT,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "coach/appointment-evaluation/occupational-therapy-coaching",
        name: "coachAppointmentEvaluationOccupationalTherapyCoaching",
        component: OccupationalTherapyCoachingList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_SUPPORT,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "coach/appointment-evaluation/private-learning-coaching",
        name: "coachAppointmentEvaluationPrivateLearningCoaching",
        component: PrivateLearningCoachingList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_SUPPORT,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
                UserRole.PRACTICE_MANAGER,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "coach/appointment-evaluation/socio-therapy-coaching",
        name: "coachAppointmentEvaluationSocioTherapyCoaching",
        component: SocioTherapyCoachingList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_SUPPORT,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
]

export default routesAnalyticsCoach;